export enum SegmentType {
    Text = 'text',
    Option = 'option',
}

export type MessageSegment = { type: SegmentType.Text; content: string } | { type: SegmentType.Option; index: number; content: string };

type AiJsonResponse = {
    message?: string;
    options?: string[];
    followUp?: string;
};

/** Parses an AI JSON response into segments: plain text and caption options.
 *  Falls back to plain text if the response is not valid JSON. */
export function parseAssistantMessage(text: string): MessageSegment[] {
    try {
        const data: AiJsonResponse = JSON.parse(text);
        const segments: MessageSegment[] = [];

        if (data.message) {
            segments.push({ type: SegmentType.Text, content: data.message });
        }

        if (data.options?.length) {
            data.options.forEach((opt, i) => {
                segments.push({ type: SegmentType.Option, index: i + 1, content: opt });
            });
        }

        if (data.followUp) {
            segments.push({ type: SegmentType.Text, content: data.followUp });
        }

        return segments.length > 0 ? segments : [{ type: SegmentType.Text, content: text.trim() }];
    } catch {
        // Fallback for non-JSON responses (general chat)
        return [{ type: SegmentType.Text, content: text.trim() }];
    }
}
